// @ts-nocheck
/**
 * YMQ Custom — Group Switcher
 *
 * Wire 2 nút điều hướng có sẵn trong Liquid để điều hướng TUẦN TỰ qua các
 * .ymq-option-group (theo đúng thứ tự DOM), kết thúc ở address group:
 *  - .ymq-button-change-state-modal--next → sang group kế tiếp
 *  - .ymq-button-change-state-modal--prev → quay lại group trước đó
 *
 * Toggle bằng class `hidden` (cần CSS `.hidden { display: none }`).
 * Đồng bộ visibility của 2 nút theo vị trí group đang hiện:
 *   Ở group cuối  → ẩn Next  (chỉ còn Previous)
 *   Ở group đầu   → ẩn Previous (chỉ còn Next)
 *
 * KHÔNG xử lý validation form — YMQ đã tự lo phần đó qua attribute
 * `ymq-option-validate="required"`: khi user click ATC mà field required
 * chưa fill, YMQ hiện error đỏ và chặn submit.
 *
 * Phụ thuộc:
 *  - 1-ymq-namespace.js phải được load trước.
 *  - 2 nút .ymq-button-change-state-modal--next / --prev phải có sẵn trong
 *    DOM (Liquid template). Toàn bộ wrapper .ymq-button-change-state-modal-wrapper
 *    sẽ được module modal di chuyển vào footer ngay sau realAtcBtn.
 *
 * Public API (gắn vào window.YMQCustom):
 *  - YMQCustom.watchAddressGroup(options?)
 *  - YMQCustom.openGroup(targetEl)
 *      → Hiện targetEl (xóa class `hidden`) và ẩn các .ymq-option-group khác
 *        (thêm class `hidden`). KHÔNG động vào class `ymq-option-group-active`.
 *
 * Options của watchAddressGroup:
 *  - addressGroupSelector:    default '.select-address-group, .address-selection'
 *  - atcSelector:             default 'button[name="add"].add-to-cart-button'
 *  - nextBtnSelector:         default '.ymq-button-change-state-modal--next'
 *  - prevBtnSelector:         default '.ymq-button-change-state-modal--prev'
 *  - timeout:                 ms tối đa đợi các element xuất hiện (default 10000)
 */

(function () {
  const YMQCustom = window.YMQCustom;
  if (!YMQCustom) {
    console.error(
      "[YMQCustom] Namespace chưa được khởi tạo. Hãy load 1-ymq-namespace.js trước.",
    );
    return;
  }

  // ============================================================
  // OPEN GROUP — toggle bằng class `hidden`
  // ============================================================
  // Cả 2 group LUÔN giữ class `ymq-option-group-active` (không động vào).
  // Việc ẩn/hiện được control qua class `hidden` + CSS `display: none`.
  // → Mở target = xóa class `hidden` khỏi target
  // → Đóng các group khác = thêm class `hidden` vào các group đó
  function openGroup(targetGroup) {
    if (!targetGroup) return;

    // Tìm tất cả group có thể được toggle. Dựa vào class `ymq-option-group`
    // chung của YMQ — sẽ match cả address-selection và product-options-group.
    const allGroups = document.querySelectorAll(".ymq-option-group");
    allGroups.forEach((el) => {
      if (el === targetGroup) {
        el.classList.remove("hidden");
      } else {
        el.classList.add("hidden");
      }
    });
  }

  // ============================================================
  // GROUP NAVIGATION HELPERS
  // ============================================================
  // Danh sách group theo đúng thứ tự DOM = thứ tự điều hướng next/prev.
  function getOrderedGroups() {
    return [...document.querySelectorAll(".ymq-option-group")];
  }

  // Index của group đang hiện (group KHÔNG có class `hidden`).
  // Trả về -1 nếu không có group nào đang hiện.
  function getActiveGroupIndex(groups) {
    return groups.findIndex((el) => !el.classList.contains("hidden"));
  }

  function isPlaceholderLike(text) {
    const value = (text || "").trim();
    if (!value) return true;
    return /選択してください/.test(value) || /^--.*--$/.test(value);
  }

  function isOptionBoxFilled(box) {
    if (box.querySelector(".ymq-app-select-placeholder")) return false;

    const select = box.querySelector("select");
    if (select) {
      const selected = select.options[select.selectedIndex];
      if (
        !selected ||
        selected.dataset.placeholder ||
        !(select.value || "").trim() ||
        isPlaceholderLike(selected.textContent)
      ) {
        return false;
      }
      return true;
    }

    const single = box.querySelector(".ymq-app-select-single");
    if (single) return !isPlaceholderLike(single.textContent);

    const optionValue = box.querySelector(
      ".ymq-app-select-values .ymq-option-value",
    );
    if (optionValue) return !isPlaceholderLike(optionValue.textContent);

    const text = box.querySelector(
      "input.ymq-option-text, input[type='text'], input[type='number'], textarea",
    );
    if (text) return !!(text.value || "").trim();

    const checks = box.querySelectorAll(
      "input[type='checkbox'], input[type='radio']",
    );
    if (checks.length) return [...checks].some((el) => el.checked);

    const selectedName = box.querySelector(".ymq-option-title-right-name");
    if (selectedName) return !isPlaceholderLike(selectedName.textContent);

    return false;
  }

  function isRequiredOptionBox(box) {
    return (
      box.getAttribute("ymq-option-validate") === "required" ||
      !!box.querySelector(".ymq-option-required, .ymq_lable.ymq-option-required")
    );
  }

  function isCountableIncompleteBox(box) {
    if (!(box instanceof HTMLElement)) return false;
    if (box.classList.contains("ymq-option-condition-hide")) return false;
    if (box.classList.contains("button-quote-price")) return false;
    if (box.classList.contains("estimate_explanation")) return false;
    if (box.classList.contains("ymq-shipping-address")) return false;

    const type = box.getAttribute("ymq-option-type");
    if (type === "11" || type === "15" || type === "26" || type === "23") {
      return false;
    }
    if (type === "6" && !isRequiredOptionBox(box)) return false;
    if (!isRequiredOptionBox(box)) return false;

    return !isOptionBoxFilled(box);
  }

  function countIncompleteRequired(groups) {
    return groups.reduce((total, group) => {
      const missing = [...group.querySelectorAll(".ymq-options-box")].filter(
        isCountableIncompleteBox,
      ).length;
      return total + missing;
    }, 0);
  }

  function getNavButtonLabel(button) {
    if (button.dataset.ymqNavLabel) return button.dataset.ymqNavLabel;
    const label = [...button.childNodes]
      .filter((node) => node.nodeType === Node.TEXT_NODE)
      .map((node) => (node.textContent || "").trim())
      .join("")
      .trim();
    button.dataset.ymqNavLabel = label;
    return label;
  }

  function ensureNavMark(button) {
    let mark = button.querySelector("[data-ymq-nav-badge]");
    if (!mark) {
      mark = document.createElement("span");
      mark.className = "ymq-nav-required hidden";
      mark.setAttribute("data-ymq-nav-badge", "");
      mark.setAttribute("aria-hidden", "true");
      button.appendChild(mark);
    }
    if ((mark.textContent || "").trim() !== "*") {
      mark.textContent = "*";
    }
    return mark;
  }

  function setNavBadge(button, count) {
    if (!button) return;
    const badge = ensureNavMark(button);
    const label = getNavButtonLabel(button);

    if (count > 0) {
      badge.classList.remove("hidden");
      button.setAttribute(
        "aria-label",
        `${label}、未入力の必須項目が${count}件あります`,
      );
      button.title = `未入力の必須項目が${count}件あります`;
      return;
    }

    badge.classList.add("hidden");
    button.removeAttribute("aria-label");
    button.removeAttribute("title");
  }

  // ============================================================
  // MAIN: WATCH ADDRESS GROUP
  // ============================================================
  async function watchAddressGroup(options = {}) {
    const {
      // Hỗ trợ cả 2 tên class — HTML hiện tại dùng `.address-selection`,
      // nếu sau này rename thành `.select-address-group` thì cũng tự match.
      addressGroupSelector = ".select-address-group, .address-selection",
      // Group thứ 2 — sẽ được mở khi nhấn nút Previous.
      atcSelector = 'button[name="add"].add-to-cart-button',
      // 2 nút riêng: Next mở address, Previous mở product options.
      nextBtnSelector = ".ymq-button-change-state-modal--next",
      prevBtnSelector = ".ymq-button-change-state-modal--prev",
      timeout = 10000,
    } = options;

    // Polling: đợi tất cả element có sẵn cùng lúc.
    const start = Date.now();
    let addressGroup = null;
    let realAtcBtn = null;
    let nextBtn = null;
    let prevBtn = null;
    while (Date.now() - start < timeout) {
      addressGroup = document.querySelector(addressGroupSelector);
      realAtcBtn = document.querySelector(atcSelector);
      nextBtn = document.querySelector(nextBtnSelector);
      prevBtn = document.querySelector(prevBtnSelector);
      if (addressGroup && realAtcBtn && nextBtn && prevBtn) break;
      await new Promise((r) => setTimeout(r, 100));
    }

    if (!addressGroup || !realAtcBtn || !nextBtn || !prevBtn) {
      console.warn("[YMQCustom] watchAddressGroup timeout:", {
        addressGroupFound: !!addressGroup,
        realAtcBtnFound: !!realAtcBtn,
        nextBtnFound: !!nextBtn,
        prevBtnFound: !!prevBtn,
        addressGroupSelector,
        atcSelector,
        nextBtnSelector,
        prevBtnSelector,
      });
      return;
    }

    // ── Trạng thái khởi tạo: hiện group ĐẦU TIÊN, ẩn các group còn lại ──
    // (Người dùng đi tuần tự qua từng group bằng Next, kết thúc ở address.)
    const initialGroup = getOrderedGroups()[0];
    if (initialGroup) {
      openGroup(initialGroup);
    }

    // ── Chặn click vào header của group (tắt toggle mặc định của YMQ) ──
    // Dùng capture phase + stopImmediatePropagation để chặn trước khi YMQ
    // handler chạy. Document-level listener vì YMQ có thể dùng event delegation
    // và header có thể bị YMQ re-render. preventDefault để chặn cả button submit.
    if (!document._ymqHeaderClickBlocked) {
      document._ymqHeaderClickBlocked = true;
      document.addEventListener(
        "click",
        (e) => {
          const header = e.target.closest('[ymq-option-action="group-header"]');
          if (header) {
            e.stopImmediatePropagation();
            e.preventDefault();
          }
        },
        true, // capture phase — quan trọng để chặn trước YMQ
      );
    }

    // ── NEXT button → sang group KẾ TIẾP theo thứ tự DOM ──
    // Đi tuần tự: group[0] → group[1] → ... → address (group cuối).
    if (nextBtn.dataset.ymqWatched !== "1") {
      nextBtn.dataset.ymqWatched = "1";
      nextBtn.addEventListener("click", (e) => {
        e.preventDefault();
        // Re-query mỗi lần — phòng trường hợp YMQ rebuild DOM.
        const groups = getOrderedGroups();
        if (!groups.length) return;
        const idx = getActiveGroupIndex(groups);
        const targetIdx = idx < 0 ? 0 : Math.min(idx + 1, groups.length - 1);
        const target = groups[targetIdx];
        if (!target) return;
        openGroup(target);
        syncBtnVisibility();
        target.scrollIntoView({ behavior: "smooth", block: "center" });
        // Logic riêng cho bước address: di chuyển form-check + focus field trống.
        if (target.matches(addressGroupSelector)) {
          YMQCustom.moveFormCheckAddress?.();
          setTimeout(() => {
            const firstEmpty = [
              ...target.querySelectorAll("select, input"),
            ].filter(
              (el) =>
                el.type !== "hidden" &&
                (!el.value || el.value === "") &&
                !el.disabled,
            )[0];
            if (firstEmpty) firstEmpty.focus();
          }, 400);
        }
      });
    }

    // ── PREVIOUS button → quay lại group TRƯỚC theo thứ tự DOM ──
    // Đi ngược: address → ... → group[1] → group[0].
    if (prevBtn.dataset.ymqWatched !== "1") {
      prevBtn.dataset.ymqWatched = "1";
      prevBtn.addEventListener("click", (e) => {
        e.preventDefault();
        const groups = getOrderedGroups();
        if (!groups.length) return;
        const idx = getActiveGroupIndex(groups);
        const targetIdx = idx < 0 ? groups.length - 1 : Math.max(idx - 1, 0);
        const target = groups[targetIdx];
        if (!target) return;
        openGroup(target);
        syncBtnVisibility();
        target.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }

    // ── Đồng bộ visibility của 2 nút theo group đang hiện ──
    //   Address visible (no .hidden)  → chỉ hiện Previous
    //   Options visible (no .hidden)  → chỉ hiện Next
    // Toggle class `hidden` trên nút (cần CSS `.hidden { display: none }`
    // — cùng class mà bạn đã dùng cho group, nên không cần thêm CSS gì).
    function syncBtnVisibility() {
      // Re-query mỗi lần — phòng trường hợp YMQ rebuild DOM khiến
      // reference cũ thành stale (element không còn trong document).
      const groups = getOrderedGroups();
      if (!groups.length) return;
      const idx = getActiveGroupIndex(groups);
      // Ẩn Next khi đang ở group CUỐI; ẩn Previous khi đang ở group ĐẦU.
      nextBtn.classList.toggle("hidden", idx >= groups.length - 1);
      prevBtn.classList.toggle("hidden", idx <= 0);

      // Slot form-check-address (ngoài ymq-option) — chỉ hiện khi group
      // hiện tại là address group.
      const current = idx >= 0 ? groups[idx] : null;
      const addressVisible = !!(
        current && current.matches(addressGroupSelector)
      );
      const addressFormSlot =
        YMQCustom.addressFormSlot ||
        document.querySelector("[data-ymq-address-form-slot]");
      if (addressFormSlot) {
        addressFormSlot.classList.toggle("hidden", !addressVisible);
      }

      const prevCount = idx > 0 ? countIncompleteRequired(groups.slice(0, idx)) : 0;
      const nextCount =
        idx >= 0 && idx < groups.length - 1
          ? countIncompleteRequired(groups.slice(idx + 1))
          : 0;
      setNavBadge(prevBtn, prevCount);
      setNavBadge(nextBtn, nextCount);
      syncAtcState();
    }
    syncBtnVisibility();

    const ymqRoot =
      document.querySelector("ymq-option") ||
      document.querySelector(".ymq-custom-modal-box") ||
      document.body;

    const refreshNavBadges = () => {
      YMQCustom.schedule("sync-nav-ui", syncBtnVisibility);
    };

    const refreshNavBadgesSoon = () => {
      refreshNavBadges();
      clearTimeout(refreshNavBadgesSoon._t1);
      clearTimeout(refreshNavBadgesSoon._t2);
      refreshNavBadgesSoon._t1 = setTimeout(syncBtnVisibility, 80);
      refreshNavBadgesSoon._t2 = setTimeout(syncBtnVisibility, 250);
    };

    YMQCustom.observeIdle(
      ymqRoot,
      {
        attributes: true,
        attributeFilter: ["class", "ymq-option-validate"],
        childList: true,
        subtree: true,
      },
      refreshNavBadgesSoon,
      "sync-btn-visibility",
    );

    if (!document._ymqNavBadgeBound) {
      document._ymqNavBadgeBound = true;
      const onYmqValueChange = (e) => {
        const el = e.target instanceof Element ? e.target : e.target?.parentElement;
        if (!el) return;
        if (
          !el.closest(
            "ymq-option, .ymq-custom-modal-wrapper, .ymq-app-select-content",
          )
        ) {
          return;
        }
        refreshNavBadgesSoon();
      };
      document.addEventListener("change", onYmqValueChange, true);
      document.addEventListener("input", onYmqValueChange, true);
      document.addEventListener(
        "click",
        (e) => {
          const el = e.target instanceof Element ? e.target : null;
          if (
            el?.closest(
              ".ymq-option-select-option-wrapper, .ymq-app-select-deselect, .ymq-checkbox-radio, .ymq-option-rc-input",
            )
          ) {
            refreshNavBadgesSoon();
          }
        },
        true,
      );
    }

    // ── Sync ATC: chỉ enable khi mọi field bắt buộc đã nhập ──
    function syncAtcState() {
      const atcBtn =
        document.querySelector('button[name="add"].add-to-cart-button') ||
        realAtcBtn;
      if (!atcBtn) return;

      const missingRequired = countIncompleteRequired(getOrderedGroups());

      // Sản phẩm báo giá (0円 + YMQ): chỉ cần đủ field bắt buộc.
      if (YMQCustom.isQuoteProduct) {
        atcBtn.disabled = missingRequired > 0;
        return;
      }

      const quoteVisible = [...document.querySelectorAll(".button-quote-price")].some(
        (btn) => !btn.classList.contains("ymq-option-condition-hide"),
      );
      const selectShippingFee = document.querySelector(
        ".shipping_fee_auto_select select",
      );
      const shippingEmpty =
        !selectShippingFee || !(selectShippingFee.value || "").trim();

      atcBtn.disabled = quoteVisible || shippingEmpty || missingRequired > 0;
    }

    YMQCustom.observeIdle(
      ymqRoot,
      { attributes: true, attributeFilter: ["class"], subtree: true },
      syncAtcState,
      "sync-atc-state",
    );
    syncAtcState();

    // ATC.disabled được sync cùng badge 戻る/次へ進む: còn field bắt buộc
    // trống trên bất kỳ page nào thì giữ disabled.
  }

  function initInitialGroup() {
    const initialGroup = getOrderedGroups()[0];
    if (initialGroup) {
      openGroup(initialGroup);
    }
  }

  // ── Expose public API ──
  YMQCustom.watchAddressGroup = watchAddressGroup;
  YMQCustom.openGroup = openGroup;
  YMQCustom.initInitialGroup = initInitialGroup;
})();
